
<template>
  <div>
    <h3></h3>
    <vs-table :data="horario">
      <template slot="thead">
        <vs-th>Clave</vs-th>
        <vs-th>Asignatura</vs-th>
        <vs-th>Profesor</vs-th>
        <vs-th>Clase en linea</vs-th>
        <vs-th  v-if="idJerarquia ==1">Editar Horario</vs-th>
        <vs-th>Lunes</vs-th>
        <vs-th>Martes</vs-th>
        <vs-th>Miércoles</vs-th>
        <vs-th>Jueves</vs-th>
        <vs-th>Viernes</vs-th>
        <vs-th>Sábado</vs-th>
        <vs-th>Domingo</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].clave">
            {{ data[indextr].clave }}
          </vs-td>
          <vs-td :data="data[indextr].nombre">
            {{ data[indextr].nombre }}
          </vs-td>
          <vs-td :data="data[indextr].profesor">
            <a :href="'mailto:' + data[indextr].correo"> {{ data[indextr].profesor }}</a>
          </vs-td>

          <vs-td :data="data[indextr].urlZoom">
            <template v-if="data[indextr].urlZoom == ''">
              <vs-button
                id="urlZoom"
                color="danger"
                size="small"
                type="filled"
                class=""
              >
                Sin link de sesión</vs-button
              >
            </template>
            <template v-else>
              <vs-button
                id="urlZoom"
                color="primary"
                size="small"
                type="filled"
                class=""
              >
                <a
                  style="color: white"
                  :href="data[indextr].urlZoom"
                  target="_blank"
                  >Link sesión</a
                ></vs-button
              >
            </template>
          </vs-td>

           <template v-if="idJerarquia ==1">  
            <vs-td >
             <vs-button
                color="warning"
                size="small"
                type="filled"
                class=""
                @click="closeGroupPopup = true;  idDetalleGrupo = data[indextr].idDetallegrupo;"
              >
                Editar Horario
                </vs-button
              >
            </vs-td>
        
         </template>
          
          <vs-td :data="data[indextr].dias[1]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[1].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[1].final
              }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].dias[2]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[2].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[2].final
              }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].dias[3]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[3].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[3].final
              }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].dias[4]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[4].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[4].final
              }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].dias[5]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[5].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[5].final
              }}</span>
            </div>
          </vs-td>
          <vs-td :data="data[indextr].dias[6]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[6].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[6].final
              }}</span>
            </div>
          </vs-td>

          <vs-td :data="data[indextr].dias[0]">
            <div>
              <span class="text-schedule">{{
                data[indextr].dias[0].inicio
              }}</span>
              <br />
              <span class="text-schedule">{{
                data[indextr].dias[0].final
              }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

     <vs-popup title="Editar Horario" :active.sync="closeGroupPopup">
      <div></div>
      <h5 class="text-center">Selecciona el día y el horario</h5>

        <div class="vx-row">
          <div class="vx-col m:w-1/1 w-full mb-4">
          <small><span class="fontBold">Día</span><span class="cssObligatorio"> *</span></small>  
              <vs-select class="w-full" placeholder="selecciona" v-model="dia">
                  <vs-select-item
                    :key="concepto.id"
                    :text="concepto.value"
                    :value="concepto.id"
                    v-for="concepto in items"/>
              </vs-select>
          </div>
        </div>
      
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-4">
              <small><span class="fontBold">Hora Inicial</span><span class="cssObligatorio"> *</span></small>  
              <vs-select class="w-full" placeholder="selecciona" v-model="horaInicial" @change="filteredHorarios()">
                    <vs-select-item 
                      :key="index" 
                      :text="item.horario" 
                      :value="item.horario" 
                      v-for="item,index in horarios" />
                </vs-select>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-4">
              <small><span class="fontBold">Hora Final</span><span class="cssObligatorio"> *</span></small>  
              <vs-select class="w-full" placeholder="selecciona" v-model="horaFinal" >
                    <vs-select-item 
                      :key="index" 
                      :text="item.horario" 
                      :value="item.horario" 
                      v-for="item,index in horariosFinales" />
                </vs-select>
          </div>
        </div>
        <vs-row vs-type="flex"
              vs-justify="right"
              class="mt-3">
            <div>
              <vs-button color="success" @click="realizarCambio">Guardar</vs-button>
            </div>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
const $ = require("jquery");

export default {
   data() {
    return {
      dia:0,
      horaInicial:'',
      horaFinal:'',
      closeGroupPopup:false,
      idJerarquia: 0,
      idDetalleGrupo: 0,
      horarios:[],
      horariosFinales:[],
      items:[
        {
          id:0,
          value:"Selecciona"
        },
        {
          id:1,
          value:"Domingo"
        },
        {
          id:2,
          value:"Lunes"
        },
        {
          id:3,
          value:"Martes"
        },
        {
          id:4,
          value:"Miércoles"
        },
        {
          id:5,
          value:"Jueves"
        },
        {
          id:6,
          value:"Viernes"
        },
        {
          id:7  ,
          value:"Sábado"
        }
      ]
    };
  },
  props: ["horario"],

   methods: {
    realizarCambio() {

        const vm = this;
        if (this.dia == 0){
          vm.showNotify(
                 201
                ,null
                ,"Debes seleccionar un día"
            );
        }

        if (this.horaInicial == ''){
          vm.showNotify(
                 201
                ,null
                ,"Debes seleccionar hora inicial"
            );
        }

        if (this.horaFinal == ''){
          vm.showNotify(
                 201
                ,null
                ,"Debes seleccionar hora final"
            );
        }
      if (this.dia != 0 && this.horaInicial != '' && this.horaFinal != ''){

          let obj = {
            idDetalleGrupo: this.idDetalleGrupo,
            dia: this.dia,
            horaInicial: this.horaInicial,
            horaFinal: this.horaFinal,
          }
          $.ajax({
            url: `${vm.$BASE.baseUrl}api/CambiarHorarioGrupo`,
            headers: {
              Authorization: sessionStorage.getItem("token"),
              pagina: "grupos",
            },
            type: "POST",
            dataType: "json",
            data: obj,
            success: function (rs) {
              if (rs.status === 200) {
                vm.limpiarControles(); 
                vm.closeGroupPopup = false;
                setTimeout(() => {
                  vm.showNotify(
                    rs.status,
                    null,
                    "El cambio de horario se guardó correctamente."
                );
                 
                 
              }, 1000);
              } else {
                vm.showNotify(rs.status);
              }
            },
            error: function (xhr, ajaxOptions, thrownError) {
            },
          });
      }
      this.$emit('cambioRealizado');
    },

    limpiarControles(){
      this.cargarHorario();
      this.dia = 0;
      this.horaInicial = this.horarios[0].horario;
      this.horaFinal = this.horarios[1].horario;
    },

    cargarHorario(){
        
        this.horarios = [  
        {
          id:1,
          horario:'07:00:00'  
        },
        {
          id:2,
          horario:'07:30:00'  
        },
         {
          id:3,
          horario:'08:00:00'  
        },
         {
          id:4,
          horario:'08:30:00'  
        },
         {
          id:5,
          horario:'09:00:00'  
        },
         {
          id:6,
          horario:'09:30:00'  
        },
         {
          id:7,
          horario:'10:00:00'  
        },
         {
          id:8,
          horario:'10:30:00'  
        },
         {
          id:9,
          horario:'11:00:00'  
        },
         {
          id:10,
          horario:'11:30:00'  
        },
         {
          id:11,
          horario:'12:00:00'  
        },
         {
          id:12,
          horario:'12:30:00'  
        },
         {
          id:13,
          horario:'13:00:00'  
        },
         {
          id:14,
          horario:'13:30:00'  
        },
         {
          id:15,
          horario:'14:00:00'  
        },
         {
          id:16,
          horario:'14:30:00'  
        },
         {
          id:17,
          horario:'15:00:00'  
        },
         {
          id:18,
          horario:'15:30:00'  
        },
         {
          id:19,
          horario:'16:00:00'  
        },
         {
          id:20,
          horario:'16:30:00'  
        },
         {
          id:21,
          horario:'17:00:00'  
        },
         {
          id:22,
          horario:'17:30:00'  
        },
         {
          id:23,
          horario:'18:00:00'  
        },
         {
          id:24,
          horario:'18:30:00'  
        },
         {
          id:25,
          horario:'19:00:00'  
        },
         {
          id:26,
          horario:'19:30:00'  
        },
         {
          id:27,
          horario:'20:00:00'  
        },
         {
          id:28,
          horario:'20:30:00'  
        },
         {
          id:29,
          horario:'21:00:00'  
        },
         {
          id:30,
          horario:'21:30:00'  
        },
         {
          id:31,
          horario:'22:00:00'  
        },
         {
          id:32,
          horario:'22:30:00'  
        },
         {
          id:33,
          horario:'23:00:00'  
        },
        {
          id:34,
          horario:'23:30:00'  
        },
        
         {
          id:35,
          horario:'24:00:00'  
        }
      ]
    },

    filteredHorarios() {
     
        const objetoEncontrado = this.horarios.find(item => item.horario === this.horaInicial);
        this.horariosFinales = this.horarios.filter(item => item.id > objetoEncontrado.id);
        this.horaFinal = this.horariosFinales[0].horario;
        return this.horariosFinales;
    }
  },

   created(){
    this.idJerarquia = sessionStorage.getItem('jerarquia');
    this.cargarHorario();
  },
};

</script>
<style>
.text-schedule {
  font-size: 12px;
}
</style>
